<script>
import { authComputed, facilityMethods } from '@state/helpers'
import NewFacilityDialog from './new-facility-dialog'

export default {
  components: {
    NewFacilityDialog,
  },
  data() {
    return {
      showFacilityDialog: false,
    }
  },
  computed: {
    ...authComputed,
    currentFacility() {
      if (!this.currentUser || !this.currentUser.currentFacility) {
        return null
      }

      return this.currentUser.currentFacility
    },
    facilities() {
      if (
        !this.currentUser ||
        !this.currentUser.organization ||
        !this.currentUser.organization.facilities
      ) {
        return []
      }

      return this.currentUser.organization.facilities
    },
  },
  methods: {
    ...facilityMethods,
    setNewFacility(facility) {
      this.changeFacility({ facilityId: facility.id })
        .then(response => {
          window.location.reload()
        })
        .catch(err => {
          this.$swal({
            title: 'Error!',
            text: err.response.data,
            type: 'error',
            confirmButtonText: 'OK',
          })
        })
    },
  },
}
</script>

<template>
  <v-card flat>
    <v-toolbar color="white" app>
      <v-spacer></v-spacer>

      <!-- Login/register -->
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn v-if="!currentUser" :to="{ name: 'login' }" flat>Log in</v-btn>
        <v-btn v-if="!currentUser" :to="{ name: 'register' }" flat
          >Sign Up</v-btn
        >

        <!-- Facility menu -->
        <!-- TODO: add functionality -->
        <v-menu v-if="currentUser" offset-y class="ml-5">
          <v-btn slot="activator" flat class="ml-2">
            <div>
              Current Facility:
              <br />
              <span>{{ currentFacility.name }}</span>
            </div>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="item in facilities"
              :key="item.id"
              @click="setNewFacility(item)"
              >{{ item.name }}</v-list-tile
            >

            <!-- Open new facility dialog -->
            <v-list-tile @click.stop="showFacilityDialog = true">
              <v-icon color="cyan" class="mr-1">add</v-icon>Add New Facility
            </v-list-tile>
            <NewFacilityDialog v-model="showFacilityDialog" />
          </v-list>
        </v-menu>

        <!-- User/logout menu -->
        <v-menu v-if="currentUser" offset-y>
          <v-btn slot="activator" flat>
            <div>{{ currentUser.name }}</div>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile :to="{ name: 'profile' }">Profile</v-list-tile>
            <v-list-tile :to="{ name: 'admin' }">Admin Panel</v-list-tile>
            <v-list-tile :to="{ name: 'logout' }">Log out</v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';

.container {
  padding: 0;
  margin: 0 0 $size-grid-padding;
  text-align: center;
  list-style-type: none;

  > li {
    display: inline-block;
    margin-right: $size-grid-padding;
  }
}

.navicon {
  display: inline-block;
  width: 50px;
}

.navtitle {
  display: flex;
  align-items: center;
  color: white !important;
  text-decoration: none;

  span {
    padding-left: 5px;
  }
}

.navtitle:hover {
  text-decoration: none;
}
</style>
